import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=8417dba4&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8417dba4",
  null
  
)

export default component.exports